<template>
  <div>
    <v-toolbar color="secondary" dark tabs>
      <v-toolbar-title>{{$tc('design.property', 2)}}</v-toolbar-title>
      <v-tabs
        v-model="tabs"
        centered
        color="secondary"
        slot="extension"
        slider-color="accent"
      >
        <v-tab
          :href="`#tab-ticker${id}-general`"
          ripple
        >
          {{$t('general.general')}}
        </v-tab>
        <v-tab
          :href="`#tab-ticker${id}-content`"
          ripple
        >
          {{$t('general.content')}}
        </v-tab>
      </v-tabs>
    </v-toolbar>

    <v-card-text>
      <v-tabs-items v-model="tabs">
        <v-tab-item :value="`tab-ticker${id}-general`">
          <v-layout row wrap>
            <v-flex xs12 pb-0>
              <h3><b>{{$t('design.position')}}</b></h3>
            </v-flex>
            <v-flex xs6 pt-1 pb-0>
              <v-text-field
                v-model.number="x"
                name="pos-x"
                label="X"
                id="pos-x"
                type="number"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs6 pt-1 pb-0>
              <v-text-field
                v-model.number="y"
                name="pos-y"
                label="Y"
                id="pos-y"
                type="number"
                disabled
              ></v-text-field>
            </v-flex>

            <v-flex xs12 pt-0 pb-0>
              <h3><b>{{$t('design.size')}}</b></h3>
            </v-flex>
            <v-flex xs6 pt-1 pb-0>
              <v-text-field
                v-model.number="w"
                name="size-w"
                :label="$t('design.width')"
                id="size-w"
                type="number"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs6 pt-1 pb-0>
              <v-text-field
                v-model.number="h"
                name="size-h"
                :label="$t('design.height')"
                id="size-h"
                type="number"
                disabled
              ></v-text-field>
            </v-flex>

            <v-flex xs12 pt-0 pb-0>
              <h3><b>{{$t('design.zIndex')}}</b></h3>
            </v-flex>
            <v-flex xs12 pt-1 pb-0>
              <v-text-field
                v-model.number="zIndex"
                name="z-index"
                :label="$t('design.zIndex')"
                id="z-index"
                type="number"
                min="0"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 pt-0 pb-0>
              <h3><b>{{$t('design.font')}}</b></h3>
            </v-flex>
            <v-flex xs12 pt-1 pb-0>
              <v-text-field
                v-model.number="fontSize"
                name="font_size"
                :label="$t('general.size')"
                id="font-size"
                type="number"
                min="1"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 pt-0 pb-0>
              <h3><b>{{$tc('design.animation', 1)}}</b></h3>
            </v-flex>
            <v-flex xs12 pt-1 pb-0>
              <v-text-field
                v-model="animationDuration"
                name="animation_duration"
                :label="$t('design.duration')"
                id="animation-duration"
                type="number"
                min="1"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 pt-0 pb-0>
              <h3><b>{{$tc('design.color', 2)}}</b></h3>
            </v-flex>
            <v-flex xs12 d-inline-flex pt-1 pb-0>
              <color-picker
                :color-type="'backgroundColor'"
                :label="$t('design.background')"
                :name="'background_color'"
              ></color-picker>
            </v-flex>
            <v-flex xs12 d-inline-flex pb-0>
              <color-picker
                :color-type="'color'"
                :label="$t('design.text')"
                :name="'color'"
              ></color-picker>
            </v-flex>
          </v-layout>
        </v-tab-item>
        <v-tab-item :value="`tab-ticker${id}-content`">
          <v-layout row wrap>
            <v-flex xs12 d-inline-flex>
              <v-text-field
                type="text"
                v-model="newFeedText"
                @keyup.enter="addFeed"
                :placeholder="$t('design.feedTextPlaceholder')"
              ></v-text-field>
              <v-btn
                color="accent"
                @click="addFeed()"
              >
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex>

            <v-flex
              v-for="(feed, index) in feeds"
              :key="index"
              d-inline-flex
              xs12
            >
              <v-text-field
                type="text"
                v-bind:value="feed"
                @input="updateFeed($event, index)"
              ></v-text-field>
              <v-btn
                color="error"
                @click="deleteFeed()"
                outline
              >
                <v-icon dark>delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </div>
</template>

<script>
import { TheMask } from 'vue-the-mask';
import { mapWidgets } from './WidgetPropertiesUtils';
import ColorPicker from './ColorPicker.vue';
import WidgetPropertiesMixin from './WidgetPropertiesMixin';

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
    TheMask,
    ColorPicker,
  },
  /* eslint-enable */
  mixins: [WidgetPropertiesMixin],
  computed: {
    ...mapWidgets(
      [
        {
          path: 'dataTicker',
          key: 'feeds',
        },
        {
          path: 'style',
          key: 'animationDuration',
        },
        {
          path: 'style',
          key: 'fontSize',
        },
        {
          path: 'style',
          key: 'color',
        },
        {
          path: 'style',
          key: 'backgroundColor',
        },
        {
          path: 'style',
          key: 'zIndex',
        },
        {
          path: 'style',
          key: 'w',
        },
        {
          path: 'style',
          key: 'h',
        },
        {
          path: 'style',
          key: 'x',
        },
        {
          path: 'style',
          key: 'y',
        },
      ],
    ),
  },
  data() {
    return {
      tabs: null,
      newFeedText: '',
    };
  },
  methods: {
    addFeed() {
      const payload = {
        data: {
          path: 'dataTicker',
          key: 'feeds',
          value: this.newFeedText,
        },
      };

      this.$store.dispatch(`widget${this.id}/PUSH_TO_ARRAY`, payload);
      this.newFeedText = '';
    },
    updateFeed(feed, index) {
      const payload = {
        index,
        value: feed,
      };

      this.$store.dispatch(`widget${this.id}/UPDATE_FEED`, payload);
    },
    deleteFeed(index) {
      this.$store.dispatch(`widget${this.id}/DELETE_FEED`, index);
    },
  },
};
</script>

<style scoped>
input:disabled {
  color: rgba(0, 0, 0, 0.26) !important;
  -webkit-text-fill-color: rgba(0, 0, 0, 0.26) !important;
}
</style>
